var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    fillRule: "evenodd",
    strokeWidth: 1.8,
    transform: "scale(-1, 1) translate(-20.46867, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(9.323266, 11.947154) scale(-1, 1) translate(-9.323266, -11.947154)",
    d: "M7.12271824,23.0852465 C3.47768737,21.2725401 0.216020271,17.4115779 0.100191112,15.9504887 C-0.0561040675,13.0283688 -0.0295152092,10.0993469 0.179802304,7.18054006 C0.491413492,2.3500701 7.42066227,0.165263902 7.71553119,0.0751406466 C8.21574915,-0.0228342565 9.2561615,0.00311031714 11.4398316,0.00311031714 C14.1278197,0.00311031714 18.5734044,3.28031962 18.5788712,7.0166796 C18.583313,7.25564278 18.6977755,13.3696864 18.6188477,16.2782096 C18.5279611,19.6066253 15.7630951,22.1157387 15.257752,22.4366321 C13.8429993,23.3561944 12.1986086,23.8611845 10.5111482,23.8943075 C9.33385577,23.8933406 8.17323601,23.6162175 7.12271824,23.0852465 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.531330, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-8.531330, -18.000000) translate(0.531330, 10.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 2.17764562,
    y1: 4.20727323,
    x2: 13.7781389,
    y2: 20.2495946
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2128);
export default __webpack_public_path__ + "static/media/21-28.e6743daff6fd5ef1dbe84c1e1e4496ca.svg";
export { ForwardRef as ReactComponent };